import axios from './axiosConfig';

export const getBetRecords = (betName, page=0) => axios.get(`/bets/${betName}/${page}`);
export const createBetRecord = (betName, betInfo) => axios.post(`/bets/${betName}`, betInfo);
export const updateBetRecord = (betName, id, betInfo) => axios.put(`/bets/${betName}/${id}`, betInfo);
export const deleteBetRecord = (betName, id) => axios.delete(`/bets/${betName}/${id}`);